// Feature: M004-F0672 (WebUI #106). Tests: T-M004-0131.
// `/Ledger` was an orphan route (LedgerAccessPage) with no nav link: the nav
// "Ledger" entry opens /app/ledger, a different page, so the same concept had
// two surfaces (UI-3). The orphan page is folded into /app/ledger; this route
// remains ONLY so that links written by Ledger nodes
// (`/Ledger?installationUuid=<uuid>`) keep working. It renders nothing and
// carries the query string across -- including across the login bounce, which
// the old page did not (it sent `redirectTo=/Ledger`, dropping the uuid).

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const LEDGER_CANONICAL_PATH = '/app/ledger';

export default function LedgerLegacyRedirect() {
  const { loading, isAuthenticated } = useAuth();
  const { search } = useLocation();
  if (loading) {
    return <main role="status" aria-label="Checking session"><p>Checking session…</p></main>;
  }
  const target = `${LEDGER_CANONICAL_PATH}${search}`;
  if (!isAuthenticated) {
    return <Navigate to={`/login?redirectTo=${encodeURIComponent(target)}`} replace />;
  }
  return <Navigate to={target} replace />;
}
